export const SortTypes = {
  dateNewToOld: "lastUpdate&desc",
  dateOldToNew: "lastUpdate&asc",
  priceHighToLow: "price_numeric&desc",
  priceLowToHigh: "price_numeric&asc",
  alphabeticallyZA: "title&desc",
  alphabeticallyAZ: "title&asc"
};

export const Amount = 12;